// extracted by mini-css-extract-plugin
module.exports = {"appIcon":"style_appIcon__qLtEt","large":"style_large__CrEss","small":"style_small__SH1g5","tiny":"style_tiny__wg0Is","xs":"style_xs__a0R4X","rounded":"style_rounded__SeDq3"};